export default __webpack_public_path__ + "static/media/storageUnit1-afterC-2048w.4e68f680.avif";